import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Compass } from 'lucide-react';
import {
  LANDING_PAGE_CONFIGS,
  LANDING_PAGE_FOOTER_ORDER,
  LANDING_PAGE_FOOTER_LABELS,
  LANDING_PAGE_THEME_FOOTER_ORDER,
  LANDING_PAGE_THEME_FOOTER_LABELS,
} from '../../pages/landingPageConfigs';

const Pill = ({ to, children, testId }) => (
  <Link
    to={to}
    data-testid={testId}
    className="inline-flex items-center min-h-[44px] px-4 rounded-full bg-white border border-gray-200 text-sm font-medium text-primary shadow-sm hover:bg-hoi-coral hover:text-white hover:border-hoi-coral transition-colors duration-200"
  >
    {children}
  </Link>
);

const Group = ({ icon: Icon, title, order, labels, prefix }) => (
  <div className="space-y-3">
    <div className="flex items-center gap-2">
      <span className="w-8 h-8 rounded-lg bg-hoi-blue/10 flex items-center justify-center flex-shrink-0">
        <Icon className="w-4 h-4 text-hoi-blue" aria-hidden="true" />
      </span>
      <h3 className="font-heading font-bold text-lg text-primary">{title}</h3>
    </div>
    <div className="flex flex-wrap gap-2.5">
      {order.map((key) => {
        const cfg = LANDING_PAGE_CONFIGS[key];
        if (!cfg) return null;
        return (
          <Pill key={key} to={cfg.slug} testId={`discover-${prefix}-${key}`}>
            {labels[key] || cfg.heading}
          </Pill>
        );
      })}
    </div>
  </div>
);

/**
 * DiscoverLinks — prominente, goed zichtbare interne-link-sectie op de homepage.
 * Vervangt de bijna-onzichtbare footer-links als primaire ingang (footer blijft
 * als secundaire sitewide navigatie bestaan). Best-practice: hoog contrast,
 * echte <a>-links, ruime tap-targets, beschrijvende ankertekst.
 */
const DiscoverLinks = () => (
  <section
    aria-labelledby="discover-links-heading"
    className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-12"
    data-testid="discover-links-section"
  >
    <div className="rounded-3xl bg-secondary/40 border border-primary/5 p-6 sm:p-8 lg:p-10">
      <div className="max-w-2xl mb-6 sm:mb-8">
        <h2 id="discover-links-heading" className="font-heading font-bold text-2xl sm:text-3xl text-primary">
          Ontdek activiteiten in Almere
        </h2>
        <p className="text-sm sm:text-base text-muted-foreground mt-2">
          Blader snel naar activiteiten in jouw wijk of naar een onderwerp dat je leuk vindt.
        </p>
      </div>
      <div className="grid gap-8 lg:grid-cols-2">
        <Group
          icon={MapPin}
          title="Per wijk"
          order={LANDING_PAGE_FOOTER_ORDER}
          labels={LANDING_PAGE_FOOTER_LABELS}
          prefix="wijk"
        />
        <Group
          icon={Compass}
          title="Per onderwerp"
          order={LANDING_PAGE_THEME_FOOTER_ORDER}
          labels={LANDING_PAGE_THEME_FOOTER_LABELS}
          prefix="thema"
        />
      </div>
    </div>
  </section>
);

export default DiscoverLinks;
